export const reduxKey = '@@publicSession';
export const actionKey = '@@publicSession';

//# sourceMappingURL=constants.js.map